import { useLayoutEffect, useMemo, useState } from "react";

import { useContractList } from "~/entity/Contract";
import { FilterIProps } from "~/entity/Contract/hooks/useContractList";
import { DealerContractIProps } from "~/entity/Contract/model/schema";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";

export type DocumentsTypeModal = "edit" | "create" | "createArr" | "history";

export const useContractTableState = (type: "main" | "additional") => {
  const [typeModal, setTypeModal] = useState<DocumentsTypeModal>();
  const [dealerObj, setDealerObj] = useState<DealerContractIProps>();
  const { page, count, dealers, contractNumber, dateFrom, dateTo } =
    useGetLocationData() as ReturnType<typeof useGetLocationData> &
      Record<string, unknown>;
  const setData = useSetLocationData();

  const filter = useMemo<FilterIProps>(() => {
    const dealerIds = String(dealers ?? "")
      .split(",")
      .filter(Boolean);
    return {
      ...(dealerIds.length
        ? { dealers: dealerIds.map((id) => ({ value: id, label: id })) }
        : {}),
      ...(contractNumber ? { id: String(contractNumber) } : {}),
      ...(dateFrom ? { dateFrom: new Date(String(dateFrom)) } : {}),
      ...(dateTo
        ? {
            dateTo: new Date(
              new Date(String(dateTo)).setHours(23, 59, 59, 999),
            ),
          }
        : {}),
    };
  }, [dealers, contractNumber, dateFrom, dateTo]);

  const { data, isLoading, refetch } = useContractList({
    filter,
    page: page.toString(),
    count: count.toString(),
    type,
  });

  useLayoutEffect(() => {
    setData("page", "0", "count", "25");
  }, []);

  const getEvent = (item, type) => {
    setTypeModal(type);
    setDealerObj(item);
  };

  const { handleCount, handlePage } = usePaginationParams();

  const closeModal = () => {
    setTypeModal(null);
    setDealerObj(null);
  };

  const closeModalRefetch = () => {
    closeModal();
    refetch();
  };

  return {
    data,
    isLoading,
    page,
    count,
    typeModal,
    dealerObj,
    getEvent,
    handleCount,
    handlePage,
    closeModal,
    closeModalRefetch,
  };
};
